import React, { useState, useRef } from 'react';
import { Link } from '@reach/router';
import Footer from '../components/footer';


export default function() {
  const [formStatus, setFormStatus] = useState('idle'); // idle, sending, success, error
  const formRef = useRef(null);

  async function sendEmail(e) {
    e.preventDefault();
    
    const form = formRef.current;
    if (!form) {
      console.error('Form element not found');
      return;
    }
    
    const success = document.getElementById("success");
    const button = document.getElementById("buttonsent");
    const failed = document.getElementById("failed");
    
    // Eğer zaten gönderiliyorsa, tekrar göndermeyi engelle
    if (formStatus === 'sending') {
      return;
    }
    
    setFormStatus('sending');
    
    const formData = new FormData(form);

    try {
      // PHP backend'e POST isteği gönder
      const response = await fetch('/contact.php', {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setFormStatus('success');
        if (success) {
          success.classList.add('show');
          success.classList.remove('hide');
        }
        if (button) {
          button.classList.add('show');
        }
        if (failed) {
          failed.classList.remove('show');
          failed.classList.add('hide');
        }
        // Formu temizle
        if (form && typeof form.reset === 'function') {
          form.reset();
        }
        // 3 saniye sonra mesajları gizle
        setTimeout(() => {
          if (success) {
            success.classList.remove('show');
            success.classList.add('hide');
          }
          if (button) {
            button.classList.remove('show');
          }
        }, 3000);
      } else {
        throw new Error(result.message || 'Form submission failed');
      }
    } catch (error) {
      console.error('Error:', error);
      setFormStatus('error');
      if (failed) {
        failed.classList.add('show');
        failed.classList.remove('hide');
      }
      if (success) {
        success.classList.remove('show');
        success.classList.add('hide');
      }
    } finally {
      setFormStatus('idle');
    }
  }

  return (
    <div>
    <style>
      {`
        .map-container {
          width: 100%;
          height: 400px;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
        }
        @media (max-width: 768px) {
          .map-container {
            height: 300px;
          }
        }
      `}
    </style>
    <section className='jumbotron breadcumb' style={{backgroundImage: `url(${'./img/bize-ulasin.jpeg'})`}}>
        <div className='mainbreadcumb'>
          <div className='container-fluid'>
            <div className='row m-10-hor'>
              <div className='col-md-6'>
                <h1>İletisim</h1>
              </div>
              <div className='col-md-6'>
                <div className='list'>
                  <Link className='link' to="/home1">Anasayfa</Link>
                  <span className='dash'>/</span>
                  <span>İletisim</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className='container-fluid black_more'>
        <div className='row m-10-hor'>
          {/* Google Maps Harita */}
          <div className='col-12' style={{ marginBottom: '40px', padding: '0 15px' }}>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3058.34955309435!2d41.295822571127424!3d39.95593682190089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMznCsDU3JzI0LjQiTiA0McKwMTcnNTAuOCJF!5e0!3m2!1str!2str!4v1765540814950!5m2!1str!2str"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Hangrup Konum Haritası"
              ></iframe>
            </div>
          </div>
          <div className='col-md-6'>
           <div className="text-side">
             <h2>Bize ulaşın </h2>
              <p>Bizimle iletişime geçmek çok kolay! Koli kutu ambalaj ürünlerimiz ve hizmetlerimizle ilgili sorularınız veya talepleriniz için bizimle iletişime geçebilirsiniz. Uzman ekibimiz, ihtiyacınıza en uygun çözümleri sunmak için her zaman hazır. Size en hızlı şekilde dönüş yaparak, kaliteli ve güvenilir hizmetlerimizden yararlanmanızı sağlayacağız</p>

              <div className='address'>
                <div className='heading'>Bilgilerimiz</div>
                <div className='list'>
                <a 
                  href="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3058.34955309435!2d41.295822571127424!3d39.95593682190089!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMznCsDU3JzI0LjQiTiA0McKwMTcnNTAuOCJF!5e0!3m2!1str!2str!4v1765540814950!5m2!1str!2str" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-map-marker"></i>
                  Soğukçermik Mah. Çevre Yolu Bulvarı NO:47 Yakutiye/Erzurum
                </a>
              </div>
                <div className='list'>
                  <i className="fa fa-envelope-o"></i>
                  <a href='mailto:info@hangrup.org' target='_blank' rel='noopener noreferrer'>
                    info@hangrup.org
                  </a>
                </div>
               <div className='list'>
                <a href="tel:+905454311191">
                  <i className="fa fa-phone"></i>
                  +90 545 431 11 91 
                </a>
              </div>
              <div className='list'>
                <a href="tel:+905382302528">
                  <i className="fa fa-phone"></i>
                    +90 538 230 25 28
                </a>
              </div>
              </div>
           </div>
          </div>
          <div className='col-md-6'>
            <div className="form-side">
              <form ref={formRef} className="formcontact" onSubmit={sendEmail}>
                <label>İsim</label>
                <input type="text" name="user_name" required />
                <label>E-posta</label>
                <input type="email" name="user_email" required />
                <label>Mesajınız</label>
                <textarea name="message" required />
                <div id='success' className='hide'>Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.</div>
                <div id='failed' className='hide'>Mesaj gönderilirken bir hata oluştu. Lütfen tekrar deneyin veya doğrudan info@hangrup.org adresine mail gönderin.</div>
                <button type="submit" id='buttonsent' disabled={formStatus === 'sending'}>
                  <span className="shine"></span>
                  <span>{formStatus === 'sending' ? 'Gönderiliyor...' : 'Gönder'}</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
